import React, { useState } from 'react'
import '../../index.css'
import './Dashboard.css'
import '../Forms/Form.css'
import Navbar from '../Layout/Navbar'
import MapComponent from '../Map/MapComponent'
import ContainRouter from '../Router/ContainRouter'
import { changeMapSize } from '../../Utils/MapTools'

export default function Dashboard() {

    const [formVisible,setFormVisible] = useState(true)

    const changeScreen = (e) => {
        let totalWidth = window.innerWidth
        let dragEndWidth = e.clientX
        let yuzde = dragEndWidth*100/totalWidth       
        if(yuzde > 80 )
            yuzde = 80
        if(yuzde < 20 )
            yuzde = 20
        changeMapSize(yuzde)
    }

    return (
        <>
            <div style={{width:'100%',height:'35px',position:'absolute',top:'0px'}} >
                <Navbar/>
            </div>
            <div className='d-flex d-inline' style={{overflow:'hidden'}} >
                <div id='contain' style={{width:'calc(36.95% - 3px)',height:'calc(100vh - 35px)',maxHeight:'calc(100vh - 35px)',overflowX:'hidden',overflowY:'scroll',padding:'5px',backgroundColor:'rgb(242, 245, 249)',marginTop:'35px'}} >
                    <div className='container-xlarge' >
                        <ContainRouter />
                    </div>
                </div>
                <div draggable onDrag={(e)=> changeScreen(e)}  onDragEnd={(e)=> changeScreen(e)} style={{cursor:'w-resize',width:'5px',height:'calc(100vh - 35px)',maxHeight:'calc(100vh - 35px)',overflowX:'hidden',backgroundColor:'#9cafcc',marginTop:'35px'}} >
                    {
                        formVisible ?
                            <button onClick={()=> {setFormVisible(false);changeMapSize(0)}} style={{marginTop:'-5px',padding:'0px',position:'absolute',zIndex:35,width:'25px'}} className='redBtn'>
                                <i className="fas fa-chevron-left"></i>
                            </button>                        
                        :
                            <button onClick={()=> {setFormVisible(true);changeMapSize(20)}} style={{marginTop:'-5px',padding:'0px',position:'absolute',zIndex:35,width:'25px'}} className='greenBtn'>
                                <i className="fas fa-chevron-right"></i>
                            </button>
                    }
                </div>
                
                <div id='mapDiv' style={{width:'calc(55% - 2px)',height:'calc(100vh - 35px)',backgroundColor:'rgb(52, 78, 117)',marginTop:'35px'}} >
                    <MapComponent />
                </div>
            </div>
        </>
    )
}
